import React, { useState } from "react";

import OldDocumentsTable from "components/OldDocumentsTable";
import OldDocumentsFilter from "components/OldDocumentsFilter";
import TermsRefresh from "views/TermsRefresh";

const DocumentsOld = (params) => {

  const notificationReference = React.useRef(null);

  const [isBusy, setIsBusy] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [documentsData, setDocumentsData] = useState([]);
  
  React.useEffect(() => {
    // console.log('DocumentsOld.React.useEffect-params?.match: ', params?.match?.params?.issuer);
    let filter = getFilter(params?.match?.params?.issuer);
    setFilterData(filter);
  }, [params?.match?.params?.issuer])

  const getFilter = (issuerId) =>{
    if (!issuerId)
      return null;

    return {
      issuerId: parseInt(issuerId),
    };
  }
  
  return (
    <React.Fragment>
      <TermsRefresh {...params} />
      <main className="main text-center">
        <OldDocumentsFilter
          simple
          data={filterData} 
          setDocumentsData={setDocumentsData}
          isBusy={isBusy}
          setIsBusy={setIsBusy}
          alertRef={notificationReference}
        />
        <OldDocumentsTable 
          filterData={filterData} 
          setFilterData={setFilterData} 
          documentsData={documentsData} 
          setIsBusy={setIsBusy}
          alertRef={notificationReference}
        />
      </main>
    </React.Fragment>
  )
}
export default DocumentsOld;